import React from 'react';
import { COLORS } from '../../../styles/tokens';
import { activeMassTypes, activeOptions, useMassCatalog } from '../../../utils/massCatalog';

// «Leverer» (utsalg) eller «Tar imot» (mottak): hvilke massetyper og undervalg stedet har. value = { typeKey: [optionKey] }.
// Deaktiverte typer og undervalg som allerede ligger i sortimentet vises nedtonet og kan bare fjernes.
export default function SupplierOffersField({ value, onChange, kind }) {
  const catalog = useMassCatalog();
  const offers = value ?? {};
  const rows = [
    ...activeMassTypes(catalog),
    ...catalog.types.filter(t => !t.active && Array.isArray(offers[t.key])),
  ];

  function toggleType(type, on) {
    const next = { ...offers };
    if (on) next[type.key] = []; else delete next[type.key];
    onChange(next);
  }
  function toggleOption(type, key, on) {
    const cur = offers[type.key] ?? [];
    onChange({ ...offers, [type.key]: on ? [...cur, key] : cur.filter(k => k !== key) });
  }
  function selectAll(type) {
    const cur = offers[type.key] ?? [];
    const activeKeys = activeOptions(type).map(o => o.key);
    onChange({ ...offers, [type.key]: [...cur.filter(k => !activeKeys.includes(k)), ...activeKeys] });
  }

  return (
    <fieldset style={styles.fieldset}>
      <legend style={styles.legend}>{kind === 'receiver' ? 'Tar imot' : 'Leverer'}</legend>
      <div style={styles.hint}>
        {kind === 'receiver'
          ? 'Velg hva mottaket tar imot. Uten valg gjelder ingen begrensning.'
          : 'Velg hva leverandøren har. Uten valg gjelder ingen begrensning.'}
      </div>
      {rows.map(type => {
        const on = Array.isArray(offers[type.key]);
        const options = type.options.filter(o => o.active || (offers[type.key] ?? []).includes(o.key));
        return (
          <div key={type.key} style={{ opacity: type.active ? 1 : 0.55 }}>
            <label style={styles.typeRow}>
              <input type="checkbox" checked={on} onChange={e => toggleType(type, e.target.checked)} />
              <span>{type.label}{!type.active && ' (deaktivert)'}</span>
            </label>
            {on && options.length > 0 && (
              <div style={styles.options}>
                {options.map(o => (
                  <label key={o.key} style={{ ...styles.optionRow, opacity: o.active ? 1 : 0.55 }}>
                    <input
                      type="checkbox"
                      aria-label={`${type.label}: ${o.label}`}
                      checked={(offers[type.key] ?? []).includes(o.key)}
                      onChange={e => toggleOption(type, o.key, e.target.checked)}
                    />
                    <span>{o.label}{!o.active && ' (deaktivert)'}</span>
                  </label>
                ))}
                {type.active && (
                  <button type="button" aria-label={`Velg alle ${type.label}`} style={styles.selectAll} onClick={() => selectAll(type)}>
                    Velg alle
                  </button>
                )}
              </div>
            )}
          </div>
        );
      })}
    </fieldset>
  );
}

const styles = {
  fieldset: { border: `1px solid ${COLORS.border}`, borderRadius: 8, padding: '8px 12px 10px', margin: 0, display: 'flex', flexDirection: 'column', gap: 4, background: COLORS.white },
  legend: { fontSize: 12, fontWeight: 600, color: COLORS.textMid, padding: '0 4px' },
  hint: { fontSize: 12, color: COLORS.textLight, marginBottom: 2 },
  typeRow: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, fontWeight: 600, color: COLORS.textDark, padding: '4px 0', cursor: 'pointer' },
  options: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px 14px', padding: '0 0 6px 26px' },
  optionRow: { display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: COLORS.textDark, cursor: 'pointer' },
  selectAll: { background: 'none', border: 'none', color: COLORS.primary, fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: '2px 4px' },
};
